import React from 'react';
import _ from 'lodash';
import { withDefaultProps } from '../utils/reactUtils';
import { SectionTitle, Section, SectionBlock } from './TwoColumnLayout';
import { Switch } from './SettingRow';
import styled from 'styled-components';

const StyledLink = styled.a`
	color: red;
`;

interface Props {
	disabled?: boolean;
	onChange: (value: string) => void;
	accountType: string;
	value: string;
	updating: boolean;
}

const defaultProps: Partial<Props> = {
	disabled: false
};

export const ServiceLimitProfileSelect: React.FC<Props> = withDefaultProps(defaultProps, (props: Props) => {
	return (
		<React.Fragment>
			<SectionTitle>Sallitut maksulliset palvelut</SectionTitle>
			<Section>
				<SectionBlock>
					<Switch
						title="Yleishyödylliset palvelut"
						updating={props.updating}
						disabled={props.disabled}
						infoText={'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
						checked={_.includes(['P2', 'P3', 'P4', 'P0'], props.value)}
						onChange={(value: any) => props.onChange(value ? 'P2' : 'P1')}
					>
						Maksulliset palvelut kuten aikataulut, tiedotuspalvelut, taksitilaus, pankkipalvelut.
					</Switch>
				</SectionBlock>
				<SectionBlock>
					<Switch
						title="Asiointipalvelut"
						disabled={props.disabled}
						updating={props.updating}
						infoText={'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
						checked={_.includes(['P3', 'P4', 'P0'], props.value)}
						onChange={(value: any) => props.onChange(value ? 'P3' : 'P2')}
					>
						Esimerkiksi tilauspalvelut, tavaroiden tai palveluiden maksaminen, mielipidemittaukset, lahjoitukset.
					</Switch>
				</SectionBlock>
				<SectionBlock>
					<Switch
						title="Viihde"
						disabled={props.disabled}
						updating={props.updating}
						infoText={'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
						checked={_.includes(['P4', 'P0'], props.value)}
						onChange={(value: any) => props.onChange(value ? 'P4' : 'P3')}
					>
						Esimerkiksi keskustelulinjat, pelit, markkinointikampanjat, äänestykset.
					</Switch>
				</SectionBlock>
				<SectionBlock>
					<Switch
						title="Aikuisviihde"
						disabled={props.disabled}
						updating={props.updating}
						infoText={'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
						checked={props.value === 'P0'}
						onChange={(value: any) => props.onChange(value ? 'P0' : 'P4')}
					>
						Aikuisviihdepalvelut
					</Switch>
				</SectionBlock>
				<SectionBlock>
					Lisätietoa estoluokista löydät{' '}
					<StyledLink href={props.accountType === 'business' ? 'https://www.moi.fi/yrityksille/asiakaspalvelu/' : 'https://asiakaspalvelu.moi.fi'} target="_blank">
						{' '}
						FAQ-osiostamme.{' '}
					</StyledLink>{' '}
				</SectionBlock>
			</Section>
		</React.Fragment>
	);
});
